import { CommonCropPledgeDebtorInformationSerializer } from '@bcba/serializers';
import { COMPANY_TYPES } from '@bcba/types';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { PledgeDebtorPFForm } from './PledgeDebtorPFForm';
import { PledgeDebtorPJForm } from './PledgeDebtorPJForm';

interface Props {
  data: CommonCropPledgeDebtorInformationSerializer;
  refetch: (
    options?: RefetchOptions,
  ) => Promise<
    QueryObserverResult<CommonCropPledgeDebtorInformationSerializer, Error>
  >;
}
export const PledgeDebtorDetail = ({ data, refetch }: Props) => {
  const { companyType } = data;

  const shouldShowPFFrom = companyType === COMPANY_TYPES.PF;

  if (shouldShowPFFrom) {
    return <PledgeDebtorPFForm data={data} refetch={refetch} />;
  }

  return <PledgeDebtorPJForm data={data} refetch={refetch} />;
};
